import {TransitionComponentType} from '@aboutyou/transitions';
import {styled} from '@linaria/react';
import React, {CSSProperties} from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {UnstyledLinkLinaria} from '../../../../atoms/UnstyledLink/UnstyledLinkLinaria';
import {LogoIconName} from '../../assets';
import {AboutYouAnniversaryLogo} from '../AboutYouAnniversaryLogo';
import {AboutNameTextLogo} from './AboutNameTextLogo';

interface Props {
  firstName?: string;
  firstNameMaxLength?: number;
  disableSvgLogo?: boolean;
  className?: string;
  dataTestId?: string;
  disableLogoLink?: boolean;
  showAYAnniversaryCampaign?: boolean;
  showHeartIcon?: boolean;
  FirstNameAnimationComponent?: TransitionComponentType;
  trackOriginClickFunction?: VoidFunction;
}

export const AboutNameLogo: React.FC<Props> = ({
  firstName,
  firstNameMaxLength,
  disableSvgLogo = false,
  dataTestId = 'AboutNameLogo',
  className,
  FirstNameAnimationComponent,
  disableLogoLink,
  showAYAnniversaryCampaign,
  showHeartIcon,
  trackOriginClickFunction,
}) => {
  if (disableSvgLogo) {
    return (
      <Container
        data-testid={dataTestId}
        className={className}
        to="/"
        onClick={trackOriginClickFunction}
        style={disableLogoLink ? disabledLinkStyles : {}}
      >
        {showAYAnniversaryCampaign && <AboutYouAnniversaryLogo />}
        <AboutNameTextLogo
          firstName={firstName}
          maxLength={firstNameMaxLength}
          showHeartIcon={showHeartIcon}
          FirstNameAnimationComponent={FirstNameAnimationComponent}
        />
      </Container>
    );
  }

  return (
    <AboutYouSVGLogo
      className={className}
      dataTestId={dataTestId}
      disableLogoLink={disableLogoLink}
      showAYAnniversaryLogo={showAYAnniversaryCampaign}
    />
  );
};

export const AboutYouSVGLogo: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
  disableLogoLink?: boolean;
  showAYAnniversaryLogo?: boolean;
}> = ({
  dataTestId,
  className,
  style,
  disableLogoLink,
  showAYAnniversaryLogo,
}) => {
  return (
    <Container
      data-testid={dataTestId}
      className={className}
      to="/"
      style={disableLogoLink ? {...disabledLinkStyles, ...style} : {...style}}
    >
      {showAYAnniversaryLogo ? (
        <AboutYouAnniversaryLogo showFullLogo />
      ) : (
        <StyledSVGLogo
          data-testid="SVGLogo"
          asset={LogoIconName.AboutYouLogo}
          fill={COLORS.Black}
        />
      )}
    </Container>
  );
};

const FONT_LOGO_HEIGHT = 34;
const Container = styled(UnstyledLinkLinaria)`
  display: flex;
  align-items: center;
  gap: 2px;
  max-height: ${FONT_LOGO_HEIGHT}px;
`;

const StyledSVGLogo = styled(Icon)`
  height: 26px;
  width: 100%;
  max-width: 132px;
`;

const disabledLinkStyles = {
  pointerEvents: 'none',
  cursor: 'not-allowed',
} as CSSProperties;
